import Cookies from 'js-cookie'
import website from '../config/website'

/**
 * 跨应用登出：设置 Cookie 标记，通知其他应用清除 localStorage
 */
export function notifyCrossAppLogout() {
  const cookieOptions = {
    domain: website.cookieDomain, 
    path: website.cookiePath || '/',
    expires: 1, // 1天后自动过期
    secure: website.cookieSecure,
    sameSite: website.cookieSameSite
  }
  // 设置登出标记（时间戳）
  Cookies.set('yzfc-logout-timestamp', Date.now().toString(), cookieOptions)
}

/**
 * 检查并处理跨应用登出标记
 * @returns {boolean} 是否检测到登出标记
 */
export function checkAndHandleCrossAppLogout() {
  const logoutTimestamp = Cookies.get('yzfc-logout-timestamp')
  if (logoutTimestamp) {
    // 清除自己的 localStorage（userInfo、token 等）
    const keyPrefix = website.key + '-'
    const keysToRemove = ['userInfo', 'token', 'refreshToken', 'tenantId', 'menu', 'menuId', 'menuAll', 'roles', 'permission']
    keysToRemove.forEach(key => {
      localStorage.removeItem(keyPrefix + key)
      sessionStorage.removeItem(keyPrefix + key)
    })
    // 清除 Cookie 标记
    const cookieOptions = {
      domain: website.cookieDomain,
      path: website.cookiePath || '/',
      secure: website.cookieSecure,
      sameSite: website.cookieSameSite
    }
    Cookies.remove('yzfc-logout-timestamp', cookieOptions)
    return true
  }
  return false
}
